import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { Modal, Button }  from 'react-bootstrap';

import { FaFlag } from 'react-icons/fa6';

import FirebaseService from "../services/firebase";
import { getDemoHomePath } from "../utils/demoUtils";
import { readRemoteSession } from "../context/RemoteLaunchContext";
import { exitGame } from "../utils/exitGame";

class GameTimeout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect: null,
            show: false,
            timeout: this.props.timeout ? this.props.timeout : 15000
        }

        this.timeout_function = null;
        this.modal_timeout_function = null;
    }

    componentDidMount(){
        this.startTimeout();
        this.registerOnClick();
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        if (this.props.timeout !== prevState.timeout) {
            this.setState({
                timeout: this.props.timeout
            }, () => {
                this.startTimeout();
            })
        }
    }

    componentWillUnmount(){
        if(this.timeout_function) clearTimeout(this.timeout_function);
        if(this.modal_timeout_function) clearTimeout(this.modal_timeout_function);
    }

    /**
     * The analytics payload for this component's events, read defensively.
     *
     * Every field here is telemetry. None of it is worth a blank screen — and
     * one of these reads produced exactly that. GameTimeout is handed the whole
     * host page with {...this} and assumed state.promo, state.venue and
     * state.player were all present. The Survivor pre-pick screen has no single
     * promo: it lists every active promotion (SUR-402), so state.promo is
     * undefined there, and "Cannot read properties of undefined (reading 'id')"
     * fired sixty seconds after the page loaded — from inside a setState
     * callback, where the only thing left to catch it is the error boundary
     * that blanks the page.
     *
     * The keys are unchanged, so the events themselves stay comparable; a
     * missing value is reported as null rather than crashing the screen it was
     * describing.
     */
    eventContext(extra){
        var state = this.props.state || {};
        return Object.assign({
            "venue_id": state.venue ? state.venue.id : null,
            "card_num": state.player ? state.player.card_number : null,
            "promo_id": state.promo ? state.promo.id : null,
        }, extra || {});
    }

    startTimeout(){
        if(this.state.show) {
            this.startModalTimeout();
            return
        };
        
        if(this.timeout_function) clearTimeout(this.timeout_function);
        this.timeout_function = setTimeout(() => {
            this.setState({
                show: true
            }, () => {
                FirebaseService.logEvent("game_timeout", this.eventContext({"timeout": this.state.timeout}))
                this.props.onTimeout();
                this.startModalTimeout();
            })
        }, this.state.timeout)
    }

    registerOnClick(){
        document.addEventListener("click", (e) => {
            this.startTimeout();
        });
        
        document.addEventListener('touchstart', (e) => {
            this.startTimeout();
        })

        document.addEventListener('touchmove', (e) => {
            this.startTimeout();
        })
        
        document.addEventListener('touchend', (e) => {
            this.startTimeout();
        })

        let scroll_container = document.querySelector('.scroll-container');
        if(scroll_container){
            scroll_container.addEventListener('scroll', (e) => {
                this.startTimeout();
            })
        }

        let user_picks_scroll_container = document.querySelector('.user-picks-scroll-container');
        if(user_picks_scroll_container){
            user_picks_scroll_container.addEventListener('scroll', (e) => {
                this.startTimeout();
            })
        }
    }

    startModalTimeout(){
        if(this.modal_timeout_function) clearTimeout(this.modal_timeout_function);
        this.modal_timeout_function = setTimeout(() => {
            FirebaseService.logEvent("game_timeout_exit", this.eventContext({"timeout": this.state.timeout/2, "manual_press": false}))
            this.goHome();
        }, this.state.timeout/2)
    }

    hideModal(){
        this.setState({
            show: false
        }, () => {
            FirebaseService.logEvent("game_timeout_clear", this.eventContext())
            if(this.modal_timeout_function) clearTimeout(this.modal_timeout_function);
            this.startTimeout();
        })
    }

    exit(){
        FirebaseService.logEvent("game_timeout_exit", this.eventContext({"timeout": this.state.timeout/2, "manual_press": true}))
        this.goHome();
    }

    goHome(){
        // Launched session: don't return to the kiosk lobby — that re-bootstraps
        // the session and loops. exitGame() knows how each flow ends: the iframe
        // posts pt:gameComplete and shows the terminal screen, a standalone web
        // session redirects to the venue's return URL.
        var remote = readRemoteSession();
        if (remote && remote.isRemote) {
            exitGame({
                remoteCtx: {
                    isRemote: true,
                    parentOrigin: remote.parentOrigin,
                    registeredThisSession: !!remote.registeredThisSession,
                },
                setRedirect: (r) => this.setState({ redirect: r }),
                result: "cancelled",
            });
            return;
        }
        this.setState({ redirect: { path: getDemoHomePath(), state: null } });
    }

    render() {
        if (this.state.redirect) {
            return <Navigate to={this.state.redirect.path} state={this.state.redirec} />
        }
        return (
            <Modal className="timeout-modal" show={this.state.show} animation={true} centered>
                <Modal.Header>
                    <Modal.Title className="w-100 text-center">
                        <div><FaFlag style={{ color: "#ffc107" }} /> Session Timeout</div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="pb-0">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <img src={(this.props.state && this.props.state.promo && this.props.state.promo.league && this.props.state.promo.league.warning_image) || "/assets/images/refree-yellow-card-2.png"} width={"200px"}/>
                            </div>
                            <div className="col text-start" style={{display: "grid", justifyContent: "center"}}>
                                <div className="pb-2">Are you still playing?</div>
                                <div className="pb-2">Press "Continue" to continue your session.</div>
                                <div>Press "Exit Game" to return to the Lobby</div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="container m-0 p-0">
                        <div className="row">
                            <div className="col d-grid"><Button variant="danger" onClick={e => this.exit()}>Exit Game</Button></div>
                            <div className="col d-grid"><Button variant="primary" onClick={e => this.hideModal()}>Continue</Button></div>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        )
    }
}
export default GameTimeout;